import React from 'react';
import { motion } from 'framer-motion';
import { ActivityIcon, HandIcon, ZapIcon, CalendarIcon, FootprintsIcon, RotateCwIcon, CrosshairIcon, VideoIcon, WrenchIcon, BrainCircuitIcon } from 'lucide-react';
const features = [{
  icon: ActivityIcon,
  text: '60+ Drills y Rutinas'
}, {
  icon: HandIcon,
  text: 'Técnica del Grip Europeo'
}, {
  icon: ZapIcon,
  text: 'Cadena Cinética'
}, {
  icon: CalendarIcon,
  text: 'Planificación de Sesiones'
}, {
  icon: FootprintsIcon,
  text: 'Juego de Pies (Split Step)'
}, {
  icon: RotateCwIcon,
  text: 'Topspin y Backspin'
}, {
  icon: CrosshairIcon,
  text: 'Estrategia de 3ra Pelota'
}, {
  icon: VideoIcon,
  text: 'Análisis de Video DIY'
}, {
  icon: WrenchIcon,
  text: 'Selección de Materiales'
}, {
  icon: BrainCircuitIcon,
  text: 'Toma de Decisiones'
}];
export function SystemSection() {
  return <section className="py-10 sm:py-16 lg:py-24 bg-navy-900" data-id="element-255">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16" data-id="element-257">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-gold-500/10 border border-gold-500/20 text-gold-400 font-bold px-3 py-1 sm:px-4 sm:py-1.5 rounded-full text-[10px] sm:text-xs md:text-sm mb-4 sm:mb-6 uppercase tracking-widest" data-id="element-258">
            Sistema completo · 3 Tomos + 3 Bonos
          </motion.div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display text-offwhite uppercase mb-2 sm:mb-4" data-id="element-259">
            EL SISTEMA N°1 EN <span className="text-blue-400" data-id="element-260">ARGENTINA</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gold-400 font-display tracking-wide" data-id="element-261">
            +60 páginas de puro valor.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4 mb-10 sm:mb-16" data-id="element-262">
          {features.map((feat, i) => {
          const Icon = feat.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-navy-800 border border-navy-700 p-3 sm:p-4 rounded-xl flex flex-col items-center text-center gap-2 sm:gap-3 hover:border-gold-500/50 hover:bg-navy-700 transition-all group cursor-pointer" data-id="element-263">
                <div className="p-2 sm:p-3 bg-navy-900 rounded-full group-hover:scale-110 transition-transform" data-id="element-264">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-gold-400" data-id="element-265" />
                </div>
                <span className="text-[11px] sm:text-xs md:text-sm font-semibold text-offwhite leading-tight" data-id="element-266">
                  {feat.text}
                </span>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-navy-800/50 border border-navy-700 rounded-2xl p-4 sm:p-6 md:p-8 text-center max-w-4xl mx-auto" data-id="element-267">
          <p className="text-sm sm:text-base md:text-lg text-offwhite font-semibold mb-1.5 sm:mb-2" data-id="element-268">
            Funciona desde hoy en tu mesa habitual.
          </p>
          <p className="text-text-secondary text-xs sm:text-sm md:text-base leading-relaxed" data-id="element-269">
            <strong className="text-gold-400" data-id="element-270">Habilidades incluidas:</strong>{' '}
            Transición rápida, Reset de postura, Debugging técnico en vivo,
            Mantenimiento de hardware, y Dominio mental.
          </p>
        </motion.div>
      </div>
    </section>;
}